import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 font-[600] font-[Figtree,_sans-serif] text-[14px]" data-id="element-186">
          "Recurso educativo digital para docentes de Secundaria"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-187">
          <span className="px-2 text-[#5B3FA0] bg-[#FFFFFF] font-[900] text-[32px]" data-id="element-188">
            MEGAPACK ESI SECUNDARIA
          </span>
        </h1>

        <h2 className="md:text-2xl mb-3 text-gray-800 text-[16px] font-[700]" data-id="element-189">
          El recurso docente que te ayuda a trabajar los principales temas de
          Educación Sexual Integral durante todo el año
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-190">
          <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-191" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-192">
          <p className="text-[14px]" data-id="element-193">
            No pierdas horas buscando actividades sobre bullying,
            consentimiento, ciudadanía digital, salud mental, diversidad o
            consumo de sustancias. Con este material vas a tener todo
            organizado, listo para imprimir y preparado para trabajar los temas
            más importantes de la ESI en secundaria.
          </p>
        </div>

        <div className="bg-blue-50 rounded-2xl p-5 max-w-md mx-auto border border-blue-100" data-id="element-194">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-195">
            👉 Acceso inmediato y organizado
          </p>
          <div className="space-y-2 text-left" data-id="element-196">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-197">
              <span className="text-green-600 mr-2 text-lg" data-id="element-198">✔️</span> Comprás
              ahora
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-199">
              <span className="text-green-600 mr-2 text-lg" data-id="element-200">✔️</span> Recibís un
              email automático
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-201">
              <span className="text-green-600 mr-2 text-lg" data-id="element-202">✔️</span> Accedés
              inmediatamente al material completo
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-203">
              <span className="text-green-600 mr-2 text-lg" data-id="element-204">✔️</span> Descargás
              o utilizás el contenido cuando lo necesites
            </p>
          </div>
        </div>
      </div>
    </section>;
}